import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { formControlLabelAlignSx } from "../../lib/ui/formLayout";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: boolean;
  helperText?: string | null;
};

const TERMS_HREF = "/legal/terms-of-service.html";
const PRIVACY_HREF = "/legal/privacy-policy.html";

/**
 * Required Terms of Service + Privacy Policy acceptance for registration flows.
 */
export default function LegalAcceptance({ checked, onChange, error, helperText }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <FormControlLabel
        sx={(theme) => {
          const base =
            typeof formControlLabelAlignSx === "function"
              ? formControlLabelAlignSx(theme)
              : formControlLabelAlignSx;
          return {
            ...(base as object),
            alignItems: "flex-start",
            mr: 0,
            ...(error ? { color: "error.main" } : {}),
          };
        }}
        control={
          <Checkbox
            size="small"
            checked={checked}
            onChange={(_, value) => onChange(value)}
            color={error ? "error" : "primary"}
            sx={{ mt: -0.25 }}
          />
        }
        label={
          <Typography variant="body2" component="span" color={error ? "error" : "text.secondary"}>
            {t("auth.register.legal.acceptPrefix")}{" "}
            <Link href={TERMS_HREF} target="_blank" rel="noopener noreferrer" underline="hover">
              {t("auth.register.legal.terms")}
            </Link>
            {t("auth.register.legal.acceptMiddle")}
            <Link href={PRIVACY_HREF} target="_blank" rel="noopener noreferrer" underline="hover">
              {t("auth.register.legal.privacy")}
            </Link>
            {t("auth.register.legal.acceptSuffix")}
          </Typography>
        }
      />
      {helperText ? (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: -0.5, ml: 4 }}>
          {helperText}
        </Typography>
      ) : null}
    </>
  );
}
